<script>
    import { beforeUpdate, afterUpdate, onMount } from 'svelte';
    import { createForm } from 'svelte-forms-lib';
    import * as yup from 'yup';

    import Uploader from '@general/uploader.svelte';
    import Input from '@general/myInput.svelte';

    export let key, updateItemsData, deleteItem, initFileName, imgUrl, update, editData, is_title_page, isadd

    let flpond, filename = '', islink = false, start_dt_arr = [], showYTimg = false, src = '', showuploader = true

    let getpic = (url) => {
        if (!url) return;

        let vid = '', urlsplt = url.split('/');

        vid = url.includes('v=') ? new URL(url).searchParams.get('v') : urlsplt[urlsplt.length - 1];
        showYTimg = true
        return `https://img.youtube.com/vi/${vid}/hqdefault.jpg`;
    }

    onMount(() => {
        if (update && !isadd) {
            form.update(v => ({
                ...editData
            }))

            showuploader = !update
            filename = initFileName
            islink = editData.media.type == 'link'
        }
    });

    let formvalues = {
        start_dt: '',
        url_link: '',
        is_title_page: is_title_page,
        text: {
            headline: "",
            text: ""
        },
        start_date: {
            day: "",
            month: "",
            year: ""
        },
        "media": {
            url: "",
            type: '',
            caption: "",
            credit: ""
        }
    }

    $: {
        if (islink) {
            $form.media.url = $form.url_link;
            src = $form.url_link !== '' && getpic($form.url_link);
            $form.media.type = 'link'
        }
        else {
            $form.media.url = filename
            $form.media.type = 'img'
        }

        start_dt_arr = $form.start_dt?.split('-') ?? []

        $form = {
            ...$form,
            start_date: {
                day: start_dt_arr[2] ?? '',
                month: start_dt_arr[1] ?? '',
                year: start_dt_arr[0] ?? ''
            }
        }

        $form.is_title_page = is_title_page
    }

    let { form, errors, handleSubmit } = createForm({
        initialValues: { ...formvalues },
        validationSchema: yup.object().shape({
            start_dt: yup.string().required('date is required'),
            text: yup.object().shape({
                headline: yup.string().required('headline is required')
            }),
            media: yup.object().shape({
                url: yup.string().required('media is required'),
                caption: yup.string().required('caption is required')
            })
        }),
        onSubmit: values => {
            let { start_dt, url_link, ...rest } = values;

            updateItemsData(
                key,
                {
                    name: filename,
                    image: flpond?.getFile()?.getFileEncodeDataURL() ?? null
                },
                { ...rest }
            );
        }
    })



</script>

<style>
    .btn2 {
        background-color: transparent;
        border: 0;
        cursor: pointer;
        font-size: 20px;
        color: red;
    }
</style>

<div class='card' style="margin: 5px; height: 600px; min-height: 600px; overflow-y: scroll; position: relative;">
    <form id='form{key}' on:submit={handleSubmit}>
        <div class='card-header' style="height: 200px; overflow-y: scroll;">
            <div class='row'>

                <div class='col-md-12'>
                    <div class="float-left">
                        <slot></slot>
                    </div>

                    <!-- {key} -->
                    <div class="float-right" style="margin-top: -10px;">
                        <button class='btn2' on:click={deleteItem(key)}>&times;</button>
                    </div>
                </div>
            </div>
            <div class='row'>
                <div class='col-md-12'>
                    <Input bind:nameval={$form.text.headline} placeholder="* Title" error={$errors.text.headline} />
                    <Input type='textarea' bind:nameval={$form.text.text} placeholder="Text..." />
                </div>
            </div>
        </div>
        <div class='card-body'>
            <div class='row'>
                <div class='col-md-12'>
                    {#if !is_title_page}
                    <Input bind:nameval={$form.start_dt} placeholder="* Date" type="date" error={$errors.start_dt} />
                    <br />
                    {/if}
                    <label>
                        <input type="checkbox" bind:checked={islink} />
                        {#if islink}
                        paste youtube link
                        {:else}
                        upload image
                        {/if}
                    </label>
                    {#if islink}
                        <Input bind:nameval={$form.url_link} placeholder="* link url" error={$errors.url_link} />
                        {#if showYTimg}
                            <img {src} alt="image" width="150" height="150" style="border-radius: 10px; box-shadow: 0 0 25px #888888;" />
                        {/if}
                    {:else}
                        {#if showuploader}
                        <Uploader {key} id='filepond{key}' bind:pond={flpond} bind:filename={filename}
                            labelIdle='Drag & Drop Image<span class="filepond--label-action"> Browse </span><br/><i style="font-size: 12px;">accepted formats: *.jpg, *.png, *.jpeg</i>'
                            acceptmediatype={['image/png', 'image/jpg' , 'image/jpeg' ]} />
                        {:else}
                        <div alt='img' class="align-items-center d-flex justify-content-center"
                            style="width: 450px; height: 450px; background: url({imgUrl}); background-size: contain; background-repeat: no-repeat;">
                            <button class="btn btn-dark" on:click={()=>{ showuploader=true }}>Edit Image</button>
                        </div>
                        {/if}
                    {/if}
                    {#if $errors.media.url !== ''}
                    <small class="error">{$errors.media.url}</small>
                    {/if}



                    <Input bind:nameval={$form.media.caption} placeholder="* Caption" error={$errors.media.caption} />

                    <Input bind:nameval={$form.media.credit} placeholder="Credits" error={$errors.media.credit} />
                    <br />
                    <small class="badge badge-danger badge-pill">* required</small>
                </div>
            </div>
        </div>
    </form>
</div>